/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/lib/react';
import { useRouter } from 'next/router';
import { theme, useBreakpoint } from '@mtsbank/ui-kit';
import { Content } from '@components/Content/Content';
import { uuid } from '@root/utils/generateUuid';
import { Payee } from '@root/api/ump-catalog-manager';
import backgroundMainDesktop from '@asserts/images/cyber/promo/vesenniiRozygrysh/bg.jpg';
import backgroundMainTablet from '@asserts/images/cyber/promo/vesenniiRozygrysh/bgTablet.jpg';
import backgroundMainMobile from '@asserts/images/cyber/promo/vesenniiRozygrysh/bgMobile.jpg';
import { PhoneInfo } from '../Cyber/PhoneInfo';
import { CyberHeader } from '../Cyber/CyberHeader';
import { Spacer } from '../Uikit/Spacer';
import { StickySearch } from '../Cyber/StickySearch';
import { CyberAutoComplete } from '../CyberAutoComplete/CyberAutoComplete';
import { Widget } from '../Cyber/Widget/Widget';
import { NpsLoader } from '../Nps/NpsLoader';
interface Props {
  children: React.ReactNode;
  servicesForSearch?: Payee[];
  withNps?: boolean;
}
const phoneInfo = [
// {
//   phone: (
//     <div style={{ display: 'flex', gap: '12px' }}>
//       <Image src={stars} width={84} height={42} />
//       <Link href="https://dzen.ru/a/ZVnvY6Zw2Ae3Gmn5">
//         <a style={{ color: 'white', cursor: 'pointer' }} target="_blank">
//           Отзывы о нас
//         </a>
//       </Link>
//     </div>
//   ),
// },
{
  phone: '@MTS_Oplata',
  region: 'Поддержка клиентов',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.106123 9.23178C0.365727 5.74365 0.495529 3.99959 2.2461 2.24902C3.99667 0.498456 5.74073 0.368654 9.22885 0.109051C10.1331 0.0417556 11.0658 0.000976562 11.9985 0.000976562C12.9313 0.000976562 13.864 0.0417564 14.7682 0.109052C18.2563 0.368657 20.0004 0.498459 21.751 2.24903C23.5015 3.9996 23.6313 5.74366 23.8909 9.23178C23.9582 10.136 23.999 11.0687 23.999 12.0015C23.999 12.9342 23.9582 13.8669 23.8909 14.7711C23.6313 18.2593 23.5015 20.0033 21.751 21.7539C20.0004 23.5045 18.2563 23.6343 14.7682 23.8939C13.864 23.9612 12.9313 24.0019 11.9985 24.0019C11.0658 24.0019 10.1331 23.9612 9.22885 23.8939C5.74072 23.6343 3.99666 23.5045 2.24609 21.7539C0.495526 20.0033 0.365724 18.2593 0.106122 14.7711C0.038826 13.8669 -0.00195312 12.9342 -0.00195312 12.0015C-0.00195312 11.0687 0.0388267 10.136 0.106123 9.23178ZM15.969 17.1923L17.9992 7.61757C18.1794 6.77327 17.696 6.44362 17.1434 6.65073L5.20831 11.249C4.39429 11.5676 4.4063 12.0241 5.06992 12.2312L8.47582 13.5072L11.6373 11.2079C11.8272 11.0353 12.1211 11.0493 12.2937 11.2392C12.4663 11.4291 12.4523 11.7229 12.2624 11.8956L9.85952 14.08L9.64078 17.1774C9.95937 17.1774 10.0973 17.0394 10.2626 16.8741L11.7551 15.4383L14.8488 17.718C15.4163 18.0361 15.8157 17.8679 15.969 17.1923Z" fill="#FAFAFA" />
      </svg>
}, {
  phone: 'cyber@mts.ru',
  region: 'По вопросам сотрудничества',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
        <path d="M6.27826 0.168102C7.43113 0.0680056 8.78358 0.000366211 10.3335 0.000366211C11.8828 0.000366211 13.2349 0.0679572 14.3876 0.167995C16.4129 0.343763 17.4255 0.431646 18.715 1.72566C19.0016 2.01328 19.2285 2.28494 19.4098 2.55483C18.6679 3.21527 17.2247 4.41723 15.5034 5.43439C15.0225 5.71852 14.5105 5.99378 13.9925 6.25423C12.0261 7.24311 11.4584 7.49773 10.3333 7.49773C9.20833 7.49773 8.64062 7.24311 6.67414 6.25423C6.15621 5.99378 5.64414 5.71852 5.1633 5.43439C3.44217 4.41736 1.99913 3.21559 1.25716 2.5551C1.43857 2.28509 1.66557 2.01331 1.95237 1.72553C3.24174 0.431744 4.25391 0.343864 6.27826 0.168102Z" fill="#FAFAFA" />
        <path d="M0.552942 4.58927C1.4197 5.31632 2.68597 6.29359 4.14585 7.15625C4.67351 7.46804 5.22648 7.76489 5.77562 8.04103C7.70681 9.01216 8.6724 9.49773 10.3333 9.49773C11.9943 9.49773 12.9599 9.01216 14.8911 8.04103C15.4402 7.76489 15.9932 7.46804 16.5208 7.15625C17.9811 6.29338 19.2475 5.31597 20.1141 4.58895C20.1681 4.98599 20.2048 5.42606 20.2469 5.93207C20.3009 6.58055 20.3338 7.27399 20.3338 8.00041C20.3338 8.72687 20.3009 9.42035 20.2469 10.0689C20.0852 12.0104 20.0044 12.9811 18.715 14.2751C17.4255 15.5691 16.413 15.657 14.3878 15.8328C13.2351 15.9328 11.8829 16.0004 10.3335 16.0004C8.78351 16.0004 7.431 15.9328 6.2781 15.8327C4.25384 15.6569 3.24171 15.569 1.95237 14.2752C0.663021 12.9815 0.582121 12.0112 0.420321 10.0707C0.366201 9.42167 0.33313 8.72756 0.33313 8.00041C0.33313 7.27327 0.366198 6.57918 0.420311 5.93016C0.462423 5.42507 0.499056 4.98571 0.552942 4.58927Z" fill="#FAFAFA" />
      </svg>
}, {
  phone: '+7 495 777-000-1',
  region: 'Для Москвы и МО',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M7.73736 3.05233C8.15847 2.95787 8.65108 2.99118 9.05206 3.1532C9.52492 3.34427 10.1855 3.69079 10.781 4.28631C11.6478 5.15299 12.0811 5.58633 12.1031 6.6226C12.1251 7.65888 11.6579 8.16754 10.7235 9.18487C10.4516 9.48082 10.1608 9.77231 9.86506 10.045L10.1701 10.4045L14.2611 14.4954L14.6185 14.7986C14.8912 14.5027 15.1828 14.2119 15.4788 13.9401C16.4962 13.0056 17.005 12.5384 18.0413 12.5604C19.0776 12.5824 19.5114 13.0162 20.3791 13.8839C20.9752 14.48 21.3221 15.1411 21.5133 15.6141C21.6754 16.0151 21.7089 16.5075 21.6146 16.9287C21.4598 17.6194 21.0888 18.711 20.2145 19.5468C19.7728 19.9794 19.3474 20.2913 18.8502 20.5225C17.1207 21.3266 15.071 21.048 13.3692 20.1867C12.0104 19.499 10.3932 18.49 8.37106 16.4679C6.34888 14.4458 5.16782 12.6567 4.48011 11.298C3.61878 9.59624 3.34009 7.54666 4.1443 5.81717C4.37408 5.32303 4.68357 4.89983 5.11203 4.46109C5.9488 3.58101 7.04456 3.20773 7.73736 3.05233Z" fill="#FAFAFA" />
      </svg>
}, {
  phone: '8 800 250-05-20',
  region: 'Бесплатно по всей России',
  icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M7.73736 3.05233C8.15847 2.95787 8.65108 2.99118 9.05206 3.1532C9.52492 3.34427 10.1855 3.69079 10.781 4.28631C11.6478 5.15299 12.0811 5.58633 12.1031 6.6226C12.1251 7.65888 11.6579 8.16754 10.7235 9.18487C10.4516 9.48082 10.1608 9.77231 9.86506 10.045L10.1701 10.4045L14.2611 14.4954L14.6185 14.7986C14.8912 14.5027 15.1828 14.2119 15.4788 13.9401C16.4962 13.0056 17.005 12.5384 18.0413 12.5604C19.0776 12.5824 19.5114 13.0162 20.3791 13.8839C20.9752 14.48 21.3221 15.1411 21.5133 15.6141C21.6754 16.0151 21.7089 16.5075 21.6146 16.9287C21.4598 17.6194 21.0888 18.711 20.2145 19.5468C19.7728 19.9794 19.3474 20.2913 18.8502 20.5225C17.1207 21.3266 15.071 21.048 13.3692 20.1867C12.0104 19.499 10.3932 18.49 8.37106 16.4679C6.34888 14.4458 5.16782 12.6567 4.48011 11.298C3.61878 9.59624 3.34009 7.54666 4.1443 5.81717C4.37408 5.32303 4.68357 4.89983 5.11203 4.46109C5.9488 3.58101 7.04456 3.20773 7.73736 3.05233Z" fill="#FAFAFA" />
      </svg>
}];
export const CyberLayout: FC<Props> = ({
  servicesForSearch,
  children,
  withNps = true
}) => {
  const [isWebView, setIsWebView] = useState(false);
  // const novogodniyRozygryshPrizov = router.pathname.includes('novogodniy-rozygrysh-prizov-itogi')
  const router = useRouter();
  const {
    isMobile,
    isTablet
  } = useBreakpoint();
  const vesenniiRozygrysh = router.pathname.split('/').includes('rozygrysh-prizov');
  const psNetwork = router.asPath.split('/').includes('playstation-network');
  const isResultPage = router.pathname.includes('result');
  useEffect(() => {
    if (window.location.search.includes('isWebView=true')) {
      setIsWebView(true);
      sessionStorage.setItem('isWebView', 'true');
    } else {
      const isWebViewFromStorage = sessionStorage.getItem('isWebView');
      if (isWebViewFromStorage) {
        setIsWebView(isWebViewFromStorage === 'true');
      }
    }
    if (window.location.search.includes('?utm_source=MM')) {
      sessionStorage.setItem('utmSource', 'true');
    }
    if (window.location.search.includes('?utm_source=launcher')) {
      sessionStorage.setItem('utmSourceLauncher', 'true');
    }
    if (window.location.search.includes('utm=membrana')) {
      sessionStorage.setItem('isMembrana', 'true');
    }
  }, []);
  return <PageContainer vesenniiRozygrysh={vesenniiRozygrysh} isMobile={isMobile} isTablet={isTablet}>
      {!isWebView && <>
          <CyberHeaderWrapper>
            <Content.Padding left={theme.spacings.lg} right={theme.spacings.lg} mobLeft={theme.spacings.sm} mobRight={theme.spacings.sm} minLeft={20} minRight={20}>
              <Container>
                <CyberHeader servicesAll={servicesForSearch} />
              </Container>
            </Content.Padding>
          </CyberHeaderWrapper>

          <WrapperSpacer>
            <Spacer space={64} spacetablet={64} spacemob={64} />
          </WrapperSpacer>
        </>}

      {isWebView && <SearchWrraper>
          <CyberAutoCompleteWrapper>
            <CyberAutoComplete servicesAllServer={servicesForSearch} />
          </CyberAutoCompleteWrapper>

          <StickySearch>
            <CyberAutoComplete servicesAllServer={servicesForSearch} />
          </StickySearch>
        </SearchWrraper>}

      <PageContent>
        <Content.Padding top={theme.spacings.md} bottom={theme.spacings.xl2} left={theme.spacings.xl2} right={theme.spacings.xl2} mobTop={theme.spacings.sm} mobBottom={48} mobLeft={theme.spacings.sm} mobRight={theme.spacings.sm} minTop={theme.spacings.xs} minBottom={theme.spacings.md} minLeft={20} minRight={20}>
          <Container>{children}</Container>
        </Content.Padding>
      </PageContent>

      {!psNetwork && !isResultPage && <Widget handleOpenWidget={() => router.push('/playstation-network')} />}

      {!isWebView && <CyberFooterWrapper>
          <Content.Padding left={theme.spacings.lg} right={theme.spacings.lg} mobLeft={theme.spacings.sm} mobRight={theme.spacings.sm} minLeft={20} minRight={20}>
            <Container>
              <Footer>
                {phoneInfo.map(({
              phone,
              region,
              icon
            }) => <PhoneInfo key={uuid()} phone={phone} region={region} icon={icon} />)}
              </Footer>
            </Container>
          </Content.Padding>
        </CyberFooterWrapper>}

      {withNps && <NpsLoader />}
    </PageContainer>;
};
const PageContainer = /*#__PURE__*/styled("div")({
  name: "PageContainer",
  class: "p1q3359r",
  vars: {
    "p1q3359r-0": [({
      vesenniiRozygrysh
    }) => vesenniiRozygrysh ? `url(${backgroundMainDesktop})` : 'none'],
    "p1q3359r-2": [({
      vesenniiRozygrysh
    }) => vesenniiRozygrysh ? `url(${backgroundMainTablet})` : 'none'],
    "p1q3359r-3": [({
      vesenniiRozygrysh
    }) => vesenniiRozygrysh ? `url(${backgroundMainMobile})` : 'none']
  }
});
const PageContent = /*#__PURE__*/styled("div")({
  name: "PageContent",
  class: "p1p7pjdb"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "crrmjqb"
});
const Footer = /*#__PURE__*/styled("div")({
  name: "Footer",
  class: "f1kn1jd1"
});
const CyberHeaderWrapper = /*#__PURE__*/styled("div")({
  name: "CyberHeaderWrapper",
  class: "c1rto3d3"
});
const CyberFooterWrapper = /*#__PURE__*/styled("div")({
  name: "CyberFooterWrapper",
  class: "clh4fd9"
});
const WrapperSpacer = /*#__PURE__*/styled("div")({
  name: "WrapperSpacer",
  class: "wun292c"
});
const SearchWrraper = /*#__PURE__*/styled("div")({
  name: "SearchWrraper",
  class: "s1rvqjmr"
});
const CyberAutoCompleteWrapper = /*#__PURE__*/styled("div")({
  name: "CyberAutoCompleteWrapper",
  class: "c1k5rk6r"
});

require("./CyberLayout.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./CyberLayout.tsx");